import script from "./StandardTractor.vue?vue&type=script&setup=true&lang=js"
export * from "./StandardTractor.vue?vue&type=script&setup=true&lang=js"

import "./StandardTractor.vue?vue&type=style&index=0&id=4fa678b8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4fa678b8"]])

export default __exports__